import { render, staticRenderFns } from "./SbMetricTiles.vue?vue&type=template&id=03a4ea9c&"
import script from "./SbMetricTiles.vue?vue&type=script&lang=js&"
export * from "./SbMetricTiles.vue?vue&type=script&lang=js&"
import style0 from "./SbMetricTiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a4ea9c')) {
      api.createRecord('03a4ea9c', component.options)
    } else {
      api.reload('03a4ea9c', component.options)
    }
    module.hot.accept("./SbMetricTiles.vue?vue&type=template&id=03a4ea9c&", function () {
      api.rerender('03a4ea9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/SbMetricTiles.vue"
export default component.exports